import { render, staticRenderFns } from "./ValueBlockShowMore.vue?vue&type=template&id=61fad4f5&scoped=true&"
import script from "./ValueBlockShowMore.vue?vue&type=script&lang=js&"
export * from "./ValueBlockShowMore.vue?vue&type=script&lang=js&"
import style0 from "./ValueBlockShowMore.vue?vue&type=style&index=0&id=61fad4f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fad4f5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
